module.exports = __webpack_public_path__ + "img/avatar.a8090d89.png";